import http from "../helpers/http";
import db from "../helpers/dbProfessionalProfile";

export default {
    namespaced: true,
    state: {
        schedule: {
            patient: db.patient,
            availabilityTime: db.availabilityTime,
            paymentMethod: db.paymentMethod,
            insurance: db.insurance,
            cancelingPolicy: db.cancelingPolicy,
            professional: db.professional,
            specialty: db.specialty,
            city: db.city,
            plan: db.plan,
        },
        paymentMethods: [],
        insurances: [],
        patients: [],
        cancelingPolicies: [],
        pixData: db.pixData,
        savedCreditCards: [],
        placeColor: db.placeColor,
    },
    mutations: {
        selectCity(state, city) {
            state.schedule.city = db.storeCity(city);
        },
        selectSpecialty(state, specialty) {
            state.schedule.specialty = db.storeSpecialty(specialty);
        },
        setPaymentMethods(state, paymentMethods) {
            state.paymentMethods = paymentMethods;
        },
        selectPaymentMethod(state, paymentMethod) {
            state.schedule.paymentMethod = db.storePaymentMethod(paymentMethod);
            state.schedule.insurance = db.storeInsurance(null);
            state.schedule.cancelingPolicy = db.storeCancelingPolicy(null);
        },
        setInsurances(state, insurances) {
            state.insurances = insurances;
        },
        selectInsurance(state, insurance) {
            state.schedule.insurance = db.storeInsurance(insurance);
        },
        selectAvailability(state, availability) {
            state.schedule.professional = db.storeProfessional(availability.professional);
            state.schedule.availabilityTime = db.storeAvailabilityTime(availability.availabilityTime);
            if (availability.professional?.place_color) {
                state.placeColor = db.storePlaceColor(availability.professional.place_color);
            }
        },
        setPlaceColor(state, color) {
            state.placeColor = db.storePlaceColor(color);
        },
        setPatients(state, patients) {
            state.patients = patients;
        },
        selectPatient(state, patient) {
            state.schedule.patient = db.storePatient(patient);
        },
        setCancelingPolicies(state, cancelingPolicies) {
            state.cancelingPolicies = cancelingPolicies;
        },
        setPixData(state, pixData) {
            state.pixData = db.storePixData(pixData);
        },
        selectCancelingPolicy(state, cancelingPolicy) {
            state.schedule.cancelingPolicy = db.storeCancelingPolicy(cancelingPolicy);
        },
        setSavedCreditCards(state, cards) {
            state.savedCreditCards = cards;
        },
        clearAll(state) {
            state.schedule.city = db.storeCity(null);
            state.schedule.specialty = db.storeSpecialty(null);
            state.schedule.insurance = db.storeInsurance(null);
            state.schedule.paymentMethod = db.storePaymentMethod(null);
            state.schedule.professional = db.storeProfessional(null);
            state.schedule.availabilityTime = db.storeAvailabilityTime(null);
            state.schedule.patient = db.storePatient(null);
            state.schedule.cancelingPolicy = db.storeCancelingPolicy(null);
            state.schedule.plan = db.storePlan(null);
            state.pixData = db.storePixData(null);
            state.paymentMethods = [];
            state.insurances = [];
            state.patients = [];
            state.cancelingPolicies = [];
            state.savedCreditCards = [];
            state.placeColor = db.storePlaceColor(null);
        },
    },
    actions: {
        getInsurances(context) {
            http.get('/schedule/insurances', {
                params: {
                    id_city: context.state.schedule.city?.id_city,
                    id_spec: context.state.schedule.specialty.id_spec,
                    id_paymeth: context.state.schedule.paymentMethod?.id_paymeth,
                    id_prof: context.state.schedule.professional?.id_prof,
                },
            }).then((insurances) => {
                context.commit('setInsurances', insurances.data);
            });
        },
        getPatients(context) {
            const userAuth = context.getters.userAuth;
            http.get(`/users/${userAuth.id_user}/patients`).then((patients) => {
                context.commit('setPatients', patients.data);
            });
        },
        getCancelingPolicies(context) {
            const schedule = context.state.schedule;
            http.get('/schedule/canceling-policies', {
                params: {
                    id_place: schedule.professional.id_place,
                    id_spec: schedule.specialty.id_spec,
                    id_prof: schedule.professional.id_prof,
                    sched_date: schedule.availabilityTime.available_date,
                    sched_time: schedule.availabilityTime.available_time,
                },
            }).then((cancelingPolicies) => {
                context.commit('setCancelingPolicies', cancelingPolicies.data);
            });
        },
        scheduleAppointment(context, schedParams) {
            const parameterCreditCard = schedParams.creditCard;
            const userAddress = schedParams.userAddress;
            const files = schedParams.files || [];
            const schedule = context.state.schedule;
            const userAuth = context.getters.userAuth;
            const formData = new FormData();

            formData.append('sched_date', schedule.availabilityTime.available_date);
            formData.append('sched_time', schedule.availabilityTime.available_time);
            formData.append('id_patient', schedule.patient.id_patient);
            formData.append('id_user', userAuth.id_user);
            formData.append('id_avail', schedule.availabilityTime.id_avail);
            formData.append('id_place', schedule.professional.id_place);
            if (schedule.availabilityTime?.id_place_location) {
                formData.append('id_place_location', schedule.availabilityTime.id_place_location);
            }
            formData.append('id_prof', schedule.professional.id_prof);
            formData.append('id_spec', schedule.specialty.id_spec);
            formData.append('id_city', schedule.city?.id_city || '');
            formData.append('id_visit_value', schedule.cancelingPolicy?.id_visit_value || '');
            formData.append('id_paymeth', schedule.paymentMethod.id_paymeth);
            formData.append('id_insurance', schedule.insurance?.id_insurance || '');
            formData.append('sched_by', 'US');
            formData.append('sched_online', schedule.availabilityTime.avail_online);
            formData.append('sched_recommended', !!schedule.professional.sched_recommended);
            formData.append('id_plan', schedule.plan?.id_plan ?? '');

            Object.entries(userAddress).forEach(([key, value]) => {
                formData.append(
                    `user_address[${key}]`,
                    value === "null" || value === null || value === undefined ? "" : value
                );
            });

            if (schedParams.creditCardTokenId) {
                formData.append('credit_card_token_id', schedParams.creditCardTokenId);
                formData.append('installments', parameterCreditCard?.installments || '');
            } else if (parameterCreditCard) {
                formData.append('installments', parameterCreditCard.installments || '');
                formData.append('gateway_payment_credit_card_data', JSON.stringify(parameterCreditCard));
                if (schedParams.saveCard) {
                    formData.append('save_card', 'true');
                    if (schedParams.cardNickname) {
                        formData.append('card_nickname', schedParams.cardNickname);
                    }
                }
            }

            files.forEach((fileData, index) => {
                formData.append(`files[${index}][name]`, fileData.name);
                formData.append(`files[${index}][file]`, fileData.file);
            });

            return http.post('/schedule/appointment', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then((response) => {
                if (schedule.paymentMethod.is_pix) {
                    context.commit('setPixData', response.data);
                    return response;
                }
                context.commit('clearAll');
                return response;
            });
        },
        getSavedCreditCards(context, cardAdministratorCode) {
            const userAuth = context.getters.userAuth;
            if (!userAuth?.id_user || !cardAdministratorCode) {
                return Promise.resolve([]);
            }
            return http.get(`/users/${userAuth.id_user}/credit-card-tokens`, {
                params: { card_administrator_code: cardAdministratorCode },
            }).then((response) => {
                context.commit('setSavedCreditCards', response.data || []);
                return response.data || [];
            }).catch(() => {
                context.commit('setSavedCreditCards', []);
                return [];
            });
        },
    },
    getters: {
        userAuth(state, _, rootState) {
            return rootState.auth.user;
        },
        placeColor(state) {
            return state.placeColor || state.schedule.professional?.place_color || '#780f5a';
        },
    },
};
